<!-- version 2021/05/20 -->
<template>
    <div class="d-flex justify-content-between">
        <app-label-text2 class="mb-0" :title="title"></app-label-text2>
        <app-normal-text v-if="isContentBold" class="mr-3" :text="text"></app-normal-text>
        <app-normal-text2 v-else class="mr-3" :text="text"></app-normal-text2>
    </div>
</template>

<script>
    export default {
        props: {
            title: String,
            text: String,
            isContentBold: Boolean
        }
    }
</script>

<style lang="sass" scoped>
</style>